var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.998698 4.66667H0.332031V0.66862C0.332031 0.299353 0.635571 0 0.993231 0H13.0042C13.3694 0 13.6654 0.29192 13.6654 0.66862V4.66667H12.9987V11.3343C12.9987 11.702 12.7021 12 12.3364 12H1.66096C1.2952 12 0.998698 11.7017 0.998698 11.3343V4.66667ZM11.6654 4.66667H2.33203V10.6667H11.6654V4.66667ZM1.66536 1.33333V3.33333H12.332V1.33333H1.66536ZM4.9987 6H8.9987V7.33333H4.9987V6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archive-icon.a0c179d74f42b7910fa2d18a6f5faf9b.svg";
export { ForwardRef as ReactComponent };